export const _initialState = {
  sandbox: {
    selectedChoice: null
  }
};
